import React, { createContext, useContext, useEffect, useState } from 'react';

const ThemeContext = createContext(null);

export function ThemeProvider({ children }) {
  const [theme, setTheme] = useState('light');
  const [isLoading, setIsLoading] = useState(true);

  // Initialize theme from localStorage on mount
  useEffect(() => {
    const stored = localStorage.getItem('findesk_theme');
    const initialTheme = stored || 'light';
    setTheme(initialTheme);
    applyTheme(initialTheme);
    setIsLoading(false);
  }, []);

  // Update document when theme changes
  useEffect(() => {
    if (!isLoading) {
      localStorage.setItem('findesk_theme', theme);
      applyTheme(theme);
    }
  }, [theme, isLoading]);

  function applyTheme(themeValue) {
    const html = document.documentElement;
    const body = document.body;
    
    if (themeValue === 'dark') {
      html.classList.add('theme-dark');
      body.classList.add('theme-dark');
    } else {
      html.classList.remove('theme-dark');
      body.classList.remove('theme-dark');
    }
  }

  function toggleTheme() {
    setTheme((prev) => (prev === 'light' ? 'dark' : 'light'));
  }

  return (
    <ThemeContext.Provider value={{ theme, toggleTheme, isLoading }}>
      {children}
    </ThemeContext.Provider>
  );
}

export function useTheme() {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error('useTheme must be used within ThemeProvider');
  }
  return context;
}
